import filterIcon from './filter.png';
import gridIcon from './grid.png';
import wheelIcon from './wheel.png';

export const icons = {
  filterIcon,
  gridIcon,
  wheelIcon,
};
